/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppButton from '../../shared/components/app-button/AppButton';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import {
  checkValidEmailAddress,
  API_DATE_FORMAT,
} from '../../shared/constants/Constants';
import FlightEmailCard from './FlightEmailCard';
import {
  formatDate,
  getNewDate,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { getValueFromAppConfig } from '../../shared/helper-utils/localStorage';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';

function EmailContent({
  selectedFlights,
  searchRequest,
  onSend,
  isRoundtrip,
  selectedRetunFlights,
}) {
  const { appConfig } = useAppContext();
  const PREF_CLASS_DICT = {
    Y: 'Economy',
    W: 'Premium Economy',
    C: 'Business',
    F: 'First Class',
  };
  const [showInput, setShowInput] = useState(true);
  const [senderEmail, setSenderEmail] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [flightOptions, setFlightOptions] = useState(
    selectedFlights.map((flight) => ({
      ...flight,
      canxCharges: '',
      amendmentCharges: '',
      sendText: false,
    })),
  );
  const [flightOptionsReturn, setFlightOptionsReturn] = useState(
    selectedRetunFlights?.map((flight) => ({
      ...flight,
      canxCharges: '',
      amendmentCharges: '',
      sendText: false,
    })),
  );
  const [needtoSend, setNeedToSend] = useState(false);

  const handleUpdatedCaxCharges = (name, value, index, type) => {
    let list = [...flightOptions];
    if (type === 'return') {
      list = [...flightOptionsReturn];
    }
    list[index][name] = value;
    if (type === 'onward') {
      setFlightOptions(list);
    }
    if (type === 'return') {
      setFlightOptionsReturn(list);
    }
  };

  const handleSendEmail = () => {
    setShowInput(false);
    if (senderEmail === '' || checkValidEmailAddress(senderEmail)) {
      setValidationError(true);
      setShowInput(true);
      return false;
    }

    setNeedToSend(true);
    setTimeout(() => {
      let content = document.getElementById('emialContent').innerHTML;

      content = content.replace(
        /width:\s*750px/g,
        'max-width: 750px; width: 100%',
      );
      onSend(senderEmail, content);
    }, 500);
  };

  return (
    <div>
      <div className="fs-14 px-4">
        <div className="d-flex align-items-center gap-3 mb-1">
          <AppRadioInput
            id="true"
            name="showBrakup"
            labelText="With Fare"
            value=""
            onChange={() => setShowBreakup(true)}
            checked={showBreakup}
          />
          <AppRadioInput
            id="false"
            name="showBrakup"
            labelText="Without Fare"
            value=""
            onChange={() => setShowBreakup(false)}
            checked={!showBreakup}
          />
        </div>
        <Row className=" my-3 spacing-8 gapbetween">
          <Col lg={8} md={8} sm={12} xs={12}>
            <AppTextInput
              name="email"
              label={isMobileWidth() ? 'Email Address' : 'Email Address'}
              placeholderText=""
              value={senderEmail}
              required
              onChange={(e) => setSenderEmail(e.target.value)}
              errorText={validationError && 'Enter Email Address'}
            />
            {checkValidEmailAddress(senderEmail) &&
              validationError &&
              senderEmail !== '' && (
                <small className="app-error-text">
                  {' '}
                  Please Enter Valid Email id
                </small>
              )}
          </Col>
          {getValueFromAppConfig('ISCORPORATECLIENT') !== 'true' &&
            showBreakup && (
              <Col lg={4} md={4} sm={12} xs={12}>
                <AppNumberInput
                  name="markUpToBeAdded"
                  label="Markup"
                  value={markUpToBeAdded}
                  onChange={(d) => setMarkupToBeAdded(d)}
                />
              </Col>
            )}
        </Row>
      </div>
      <div className="d-flex justify-content-center align-items-center hide-in-mobile">
        <div className="overflow-auto " style={{ height: '300px' }}>
          <div id="emialContent">
            <div
              style={{
                width: '750px',
                color: '#000',
                padding: '1rem',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <div
                className="show-no-border-in-mobile"
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                }}
              >
                <div
                  style={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    color: '#fff',
                    backgroundColor: appConfig?.clientPrimaryColor,
                    fontSize: '14px',
                  }}
                >
                  <div
                    style={{
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '16px',
                      padding: '16px',
                      fontSize: '12px',
                      borderBottom: '1px solid #ccc',
                    }}
                    className="d-none"
                  >
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: 'left',
                              fontWeight: '600',
                              fontSize: '14px',
                            }}
                          >
                            {searchRequest.originLocation.split(',')[0]} -{' '}
                            {searchRequest.destinationLocation.split(',')[0]}
                          </td>
                          <td style={{ textAlign: 'end', fontSize: '12px' }}>
                            Traveler Class :{' '}
                            <span
                              style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                              {PREF_CLASS_DICT[searchRequest.prefclass]}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'left' }}>
                            Travel Dates :{' '}
                            <span
                              style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                              {formatDate(
                                getNewDate(searchRequest.onwarddate),
                                API_DATE_FORMAT,
                              )}{' '}
                              {isRoundtrip &&
                                `${formatDate(
                                  getNewDate(searchRequest.returndate),
                                  API_DATE_FORMAT,
                                )}`}
                            </span>
                          </td>
                          <td style={{ textAlign: 'end' }}>
                            Passenger(s):{' '}
                            <span
                              style={{ fontWeight: '600', fontSize: '14px' }}
                            >
                              {parseInt(searchRequest.numadults, 10)} Adult
                              {parseInt(searchRequest.numchildren, 10) > 0 &&
                                ` ${parseInt(
                                  searchRequest.numchildren,
                                  10,
                                )} Child`}
                              {parseInt(searchRequest.numinfants, 10) > 0 &&
                                ` ${parseInt(
                                  searchRequest.numinfants,
                                  10,
                                )} Infant`}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {flightOptions.map((selectedFlight, index) => {
                  const isLastFlight =
                    index === flightOptions.length - 1 &&
                    (!flightOptionsReturn || flightOptionsReturn.length === 0);
                  const hasQuotation =
                    getValueFromAppConfig('qoutationShare') === 'true' &&
                    (!needtoSend || selectedFlight.sendText);

                  return (
                    <React.Fragment key={selectedFlight.fare.nextraflightkey}>
                      <FlightEmailCard
                        key={selectedFlight.fare.nextraflightkey}
                        flight={selectedFlight.flight}
                        isLast={hasQuotation ? true : isLastFlight}
                        showHideFare={showBreakup}
                        fare={selectedFlight.fare}
                        searchRequest={searchRequest}
                        markUpToBeAdded={markUpToBeAdded}
                        index={index}
                        isOnward
                        showInput={showInput}
                        onFareUpdate={() => {}}
                      />
                      {hasQuotation && (
                        <table
                          style={{
                            width: '100%',
                            backgroundColor: '#fff',
                            borderBottom: isLastFlight
                              ? 'none'
                              : '1px solid #ccc',
                          }}
                        >
                          <tbody>
                            {!needtoSend && (
                              <tr>
                                <td
                                  style={{
                                    border: 'none',
                                    fontSize: '12px',
                                    padding: '8px 16px',
                                  }}
                                >
                                  <AppCheckBox
                                    id={`sendText_onward_${index}`}
                                    name={`sendText_onward_${index}`}
                                    labelText="Add Cancellation & Change Charges"
                                    checked={selectedFlight.sendText}
                                    onChange={() =>
                                      handleUpdatedCaxCharges(
                                        'sendText',
                                        !selectedFlight.sendText,
                                        index,
                                        'onward',
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            )}
                            {selectedFlight.sendText && (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      border: 'none',
                                      fontSize: '12px',
                                      padding: '4px 16px',
                                      color: '#141f3b',
                                    }}
                                  >
                                    {needtoSend ? (
                                      `Cancellation Charges/Passenger: ${selectedFlight.canxCharges} INR`
                                    ) : (
                                      <div className="d-flex align-items-center gap-2">
                                        <span>
                                          Cancellation Charges/Passenger:
                                        </span>
                                        <input
                                          type="text"
                                          className="text-input-for-email"
                                          value={selectedFlight.canxCharges}
                                          onChange={(e) =>
                                            handleUpdatedCaxCharges(
                                              'canxCharges',
                                              e.target.value,
                                              index,
                                              'onward',
                                            )
                                          }
                                        />
                                        <span>INR</span>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      border: 'none',
                                      fontSize: '12px',
                                      padding: '4px 16px 8px 16px',
                                      color: '#141f3b',
                                    }}
                                  >
                                    {needtoSend ? (
                                      `Amendment Charges/ Passenger: ${selectedFlight.amendmentCharges} + Applicable fare Difference`
                                    ) : (
                                      <div className="d-flex align-items-center gap-2">
                                        <span>
                                          Amendment Charges/ Passenger:
                                        </span>
                                        <input
                                          type="text"
                                          className="text-input-for-email"
                                          value={
                                            selectedFlight.amendmentCharges
                                          }
                                          onChange={(e) =>
                                            handleUpdatedCaxCharges(
                                              'amendmentCharges',
                                              e.target.value,
                                              index,
                                              'onward',
                                            )
                                          }
                                        />
                                        <span>
                                          + Applicable fare Difference
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      )}
                    </React.Fragment>
                  );
                })}
                {flightOptionsReturn.length > 0 &&
                  flightOptionsReturn.map((selectedFlight, index) => {
                    const isLastFlight =
                      index === flightOptionsReturn.length - 1;
                    const hasQuotation =
                      getValueFromAppConfig('qoutationShare') === 'true' &&
                      (!needtoSend || selectedFlight.sendText);

                    return (
                      <React.Fragment key={selectedFlight.fare.nextraflightkey}>
                        <FlightEmailCard
                          key={selectedFlight.fare.nextraflightkey}
                          flight={selectedFlight.flight}
                          isLast={hasQuotation ? true : isLastFlight}
                          showHideFare={showBreakup}
                          fare={selectedFlight.fare}
                          index={index}
                          searchRequest={searchRequest}
                          markUpToBeAdded={markUpToBeAdded}
                          showInput={showInput}
                          onFareUpdate={() => {}}
                        />
                        {hasQuotation && (
                          <table
                            style={{
                              width: '100%',
                              backgroundColor: '#fff',
                              borderBottom: isLastFlight
                                ? 'none'
                                : '1px solid #ccc',
                            }}
                          >
                            <tbody>
                              {!needtoSend && (
                                <tr>
                                  <td
                                    style={{
                                      border: 'none',
                                      fontSize: '12px',
                                      padding: '8px 16px',
                                    }}
                                  >
                                    <AppCheckBox
                                      id={`sendText_return_${index}`}
                                      name={`sendText_return_${index}`}
                                      labelText="Add Cancellation & Change Charges"
                                      checked={selectedFlight.sendText}
                                      onChange={() =>
                                        handleUpdatedCaxCharges(
                                          'sendText',
                                          !selectedFlight.sendText,
                                          index,
                                          'return',
                                        )
                                      }
                                    />
                                  </td>
                                </tr>
                              )}
                              {selectedFlight.sendText && (
                                <>
                                  <tr>
                                    <td
                                      style={{
                                        border: 'none',
                                        fontSize: '12px',
                                        padding: '4px 16px',
                                        color: '#141f3b',
                                      }}
                                    >
                                      {needtoSend ? (
                                        `Cancellation Charges/Passenger: ${selectedFlight.canxCharges} INR`
                                      ) : (
                                        <div className="d-flex align-items-center gap-2">
                                          <span>
                                            Cancellation Charges/Passenger:
                                          </span>
                                          <input
                                            type="text"
                                            className="text-input-for-email"
                                            value={selectedFlight.canxCharges}
                                            onChange={(e) =>
                                              handleUpdatedCaxCharges(
                                                'canxCharges',
                                                e.target.value,
                                                index,
                                                'return',
                                              )
                                            }
                                          />
                                          <span>INR</span>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        border: 'none',
                                        fontSize: '12px',
                                        padding: '4px 16px 8px 16px',
                                        color: '#141f3b',
                                      }}
                                    >
                                      {needtoSend ? (
                                        `Amendment Charges/ Passenger: ${selectedFlight.amendmentCharges} + Applicable fare Difference`
                                      ) : (
                                        <div className="d-flex align-items-center gap-2">
                                          <span>
                                            Amendment Charges/ Passenger:
                                          </span>
                                          <input
                                            type="text"
                                            className="text-input-for-email"
                                            value={
                                              selectedFlight.amendmentCharges
                                            }
                                            onChange={(e) =>
                                              handleUpdatedCaxCharges(
                                                'amendmentCharges',
                                                e.target.value,
                                                index,
                                                'return',
                                              )
                                            }
                                          />
                                          <span>
                                            + Applicable fare Difference
                                          </span>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        )}
                      </React.Fragment>
                    );
                  })}
                <div
                  style={{
                    backgroundColor: '#333333',
                    borderTop: '1px solid #ccc',
                    color: '#fff',
                    padding: '10px',
                    fontSize: '12px',
                    borderBottomLeftRadius: '8px',
                    borderBottomRightRadius: '8px',
                  }}
                  className="d-none"
                >
                  <span style={{ fontSize: '14px', marginBottom: '10px' }}>
                    Terms & Conditions:
                  </span>
                  <ul>
                    <li>
                      All Travel timings are as per the local time in 24hrs
                      format
                    </li>
                    <li>
                      Check passenger name and Travel Itinerary details
                      carefully
                    </li>
                    <li>
                      Names provided should be with Valid Government Approved
                      Photo ID/ Passport
                    </li>
                    <li>
                      Automated Ticketing time limit provided as per airline
                    </li>
                    <li>
                      Ensure Sufficient Funds are available for confirmation of
                      services
                    </li>
                    <li>
                      Fares and Taxes are subject to availability at the time of
                      issuance
                    </li>
                    <li>
                      We are not liable if any increase occurs due to ROE
                      fluctuation and taxes
                    </li>
                    <li>
                      Check all Visa requirement for Destination and Transit
                      country with the respective airline and embassy
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handleSendEmail}
          btnText="Send Email"
        />
      </div>
    </div>
  );
}

EmailContent.defaultProps = {
  selectedRetunFlights: [],
  isRoundtrip: undefined,
};

EmailContent.propTypes = {
  selectedFlights: PropTypes.array.isRequired,
  selectedRetunFlights: PropTypes.array,
  searchRequest: PropTypes.object.isRequired,
  onSend: PropTypes.func.isRequired,
  isRoundtrip: PropTypes.any,
};

export default EmailContent;
